import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const ShareSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        d="M6.9 0C7.60223 0 7.95026 0.39551 7.95026 1C7.95026 1.55322 7.6585 2 6.9 2H3.21223C2.6536 2 2 2.55713 2 3.21223C2 3.86733 2 12.3702 2 12.8489C2 13.3277 2.57226 14 3.21223 14C3.85219 14 12.8489 14 12.8489 14C13.5261 14 14 13.4534 14 12.8489V11.3451C14 10.9016 14.3226 10.4397 15 10.4397C15.6774 10.4397 16.0611 10.9595 16.0611 11.3451V12.8489C16.0611 14.623 14.623 16.0611 12.8489 16.0611H3.21223C1.43816 16.0611 0 14.623 0 12.8489V3.21223C0 1.43816 1.43816 0 3.21223 0H6.9Z"
        fill="#55585E"
      />
      <path
        d="M5.24645 11.068C5.24645 9.17164 4.29839 5.37891 12.8319 5.37891"
        stroke="#55585E"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M10.2654 3.20459C9.8951 2.8343 9.8951 2.23394 10.2654 1.86365C10.6357 1.49337 11.236 1.49337 11.6063 1.86365L14.4509 4.7082C14.8212 5.07849 14.8212 5.67885 14.4509 6.04913L11.6063 8.89368C11.236 9.26397 10.6357 9.26397 10.2654 8.89368C9.8951 8.52339 9.8951 7.92304 10.2654 7.55275L12.4395 5.37867L10.2654 3.20459Z"
        fill="#55585E"
      />
    </svg>
  </span>
);

export default ShareSVG;
